export default "__VITE_ASSET__7f38efda__"